import cn from 'classnames';
import { CallingAvatar } from 'src/components/SpeakingAvatar/CallingAvatar/CallingAvatar';
import { VoiceChannelMember } from 'src/provider/VoiceChannel';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { ParticipantVideoStream } from './ParticipantVideoStream';
import { CustomCallingAvatar, StyledAiLoading } from './styles';
import { useMemberVariables } from './useMemberVariables';

type Props = {
  member: VoiceChannelMember;
  connected: boolean;
  isFromNav: boolean;
  aloneMember: boolean;
};
export const MemberContent = ({
  member,
  connected,
  isFromNav,
  aloneMember,
}: Props) => {
  const { connectionStatus, aiStatus, channelLockedBy } = useLivekitRTCState();

  const { hasVideo, isSmall } = useMemberVariables({
    member,
    connected,
    aloneMember,
  });

  if (!member?.user?.name) return null;

  if (hasVideo && connectionStatus === 'connected')
    return (
      <ParticipantVideoStream
        meetId={member.meetId}
        identity={member.identity}
        camera={member.camera}
        isFromNav={isFromNav}
      />
    );

  if (aiStatus === 'speaking' && channelLockedBy === member.meetId) {
    return <StyledAiLoading />;
  }

  return (
    <CallingAvatar
      inviteStatus={member.status}
      size={isSmall ? 'medium' : 'xLarge'}
    >
      <CustomCallingAvatar
        src={member.user.picture}
        name={member.user.name}
        alt={member.user.name}
        className={cn(member.status, { isSmall })}
      />
    </CallingAvatar>
  );
};
